
import { Cropper } from 'vue-advanced-cropper';
import {
  defineComponent, ref, Ref,
} from 'vue';

import 'vue-advanced-cropper/dist/style.css';
import { IImageCrop } from '@/types/interfaces';

import AppLoader from './UI/AppLoader.vue';

export default defineComponent({
  emits: ['on-cancel', 'on-crop'],
  components: { Cropper, AppLoader },
  props: {
    image: { type: Object as () => IImageCrop, required: true },
    isCaseCropper: { type: Boolean, default: false },
    hideRotateLeft: { type: Boolean, default: false },
  },
  setup(props, context) {
    const loader: Ref<string> = ref('');
    const lockUI = ref(false);
    const crop = ref(null as any);
    const profileStencil = {
      aspectRatio: 1,
      previewClass: 'preview',
      movable: false,
      resizable: false,
    };

    const caseStencil = {
      resizable: true,
    };

    function handleCrop() {
      lockUI.value = true;
      console.log('1', lockUI.value);
      const { coordinates, imageTransforms, image } = crop!.value!.getResult();
      const imgCoordinates = { ...coordinates, rotate: imageTransforms.rotate };
      if (imageTransforms.rotate === -90 || imageTransforms.rotate === 270) {
        imgCoordinates.width = coordinates.height;
        imgCoordinates.height = coordinates.width;
        imgCoordinates.top = coordinates.left;
        imgCoordinates.left = image.width - coordinates.top - coordinates.height;
      }
      if (imageTransforms.rotate === -180 || imageTransforms.rotate === 180) {
        imgCoordinates.top = image.height - coordinates.top - coordinates.height;
        imgCoordinates.left = image.width - coordinates.left - coordinates.width;
      }
      if (imageTransforms.rotate === -270 || imageTransforms.rotate === 90) {
        imgCoordinates.width = coordinates.height;
        imgCoordinates.height = coordinates.width;
        imgCoordinates.top = image.height - coordinates.left - coordinates.width;
        imgCoordinates.left = coordinates.top;
      }
      lockUI.value = false;
      console.log('2', lockUI.value);
      context.emit('on-crop', imgCoordinates);
    }

    function handleRotateLeft() {
      crop!.value!.rotate(-90);
    }
    function handleRotateRight() {
      crop!.value!.rotate(90);
    }

    function defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    }

    return {
      lockUI,
      crop,
      profileStencil,
      caseStencil,
      loader,
      handleCrop,
      handleRotateLeft,
      handleRotateRight,
      defaultSize,
    };
  },
});
